<div class="wrapper">
  <div class="background" [ngStyle]="appTestEnvironment ? { 'background-image': 'none' } : ''">
    <div class="background-overlay">
      <div class="d-flex justify-content-center align-items-center py-5 mt-5">
        <div class="col-xs-1 col-md-2"></div>
        <div class="col-xs-10 col-md-8">
          <div *ngIf="appTestEnvironment" style="width: 100%; overflow: hidden; white-space: nowrap; box-sizing: border-box">
            <div style="display: inline-block; padding-left: 100%; animation: marquee 10s linear infinite">NOTE: YOU ARE IN TEST MODE</div>
          </div>
          <div class="card shadow rounded" style="background-color: rgba(0, 0, 0, 0.1)">
            <div class="card-header text-white text-center pb-0 mb-0">
              <h1 class="title-heading pb-0 mb-0">EMAIL TEMPORARY PASSWORD</h1>
            </div>
            <div style="background-color: rgba(0, 0, 0, 0.3)">
              <div class="card-body text-white text-center">
                <p>
                  Please enter your email address to send you a temporary password to use to login.
                  <br />
                  After you login with this temporary password you will be required to change it.
                </p>
                <form [formGroup]="forgotPasswordForm" class="login-container" (ngSubmit)="submit()">
                  <div class="formGroup pb-2 row">
                    <div class="col-3">
                      <label for="username">EMAIL<span class="text-danger">*</span></label>
                    </div>
                    <div class="col-9">
                      <input type="username" class="form-control" placeholder="Email" formControlName="email" />
                    </div>
                  </div>
                  <div *ngIf="forgotPasswordForm.controls['email'].touched && forgotPasswordForm.controls['email'].errors" class="text-white row">
                    <div class="offset-3 col-9" style="position:absolute">Valid email address is required.</div>
                  </div>
                  <div class="formGroup text-right pt-3">
                    <span class="pr-5">
                      <button type="submit" class="btn text-white" [disabled]="!forgotPasswordForm.valid || (loading$ | async)">
                        <pos-app-spinner2 *ngIf="loading$ | async"></pos-app-spinner2>
                        SEND EMAIL
                      </button>
                    </span>
                    <span class="px-2"></span>
                    <button type="button" class="btn btn-cancel" [routerLink]="['/login']">CANCEL</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-1 col-md-2 col-xl"></div>
      </div>
    </div>
  </div>
</div>
